/* Trolley'd shared enquiry attribution, v4 candidate. No submission or conversion events. */
(function () {
  'use strict';
  if (window.TDCPSearchV4) { window.TDCPSearchV4.refresh(); return; }
  const UTM = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','utm_id'];
  const ADS = ['gclid','gbraid','wbraid','fbclid','msclkid'];
  const KEYS = UTM.concat(ADS);
  const STORE = 'tdcp_attribution_v4';
  const WITHDRAWN = 'tdcp_attribution_withdrawn_v4';
  // Proposed conservative retention: fixed 30-minute window, or end of tab session, whichever is earlier.
  const RETENTION = 30 * 60 * 1000;
  const FORMS = [
    'https://forms.zohopublic.com.au/trolleyd/form/CorporateLeadCapture/formperma/NL8sex72FKtoAdXXvqOPvyJCi_i75uw19bQDF1_hKl8',
    'https://forms.zohopublic.com.au/trolleyd/form/EnquiryForm/formperma/UZj431FAsNELzWeaOwO9XFbN8hkjol-LepLAD_PQldU'
  ];
  let memory = null;
  let cleanup = function () {};
  let lastPermission = null;
  let queryHandled = false;
  let suppression = false;
  try { suppression = sessionStorage.getItem(WITHDRAWN) === '1'; } catch (_) {}
  function permissions() {
    try {
      const p = window.Shopify && window.Shopify.customerPrivacy;
      return {ready:!!p, analytics:!!(p && p.analyticsProcessingAllowed()), marketing:!!(p && p.marketingAllowed())};
    } catch (_) { return {ready:false,analytics:false,marketing:false}; }
  }
  function clean(values) {
    const result = {};
    KEYS.forEach(function(key) {
      const value = values && values[key];
      // Never truncate and misidentify a campaign. Reject controls, full URLs and obvious email addresses.
      if (typeof value !== 'string' || !value.trim() || value.length > 255 || /[\u0000-\u001f\u007f]|@|:\/\//.test(value)) return;
      if (ADS.indexOf(key) !== -1 && !/^[A-Za-z0-9_.~-]+$/.test(value)) return;
      result[key] = value;
    });
    return result;
  }
  function purge() {
    memory = null;
    try { sessionStorage.removeItem(STORE); } catch (_) {}
    try { sessionStorage.removeItem('tdcp_attribution_v3'); } catch (_) {}
    KEYS.forEach(function(key) { try { sessionStorage.removeItem('td_' + key); } catch (_) {} });
  }
  function storedRecord() {
    try {
      const r = JSON.parse(sessionStorage.getItem(STORE) || 'null');
      const now = Date.now();
      if (!r || r.version !== 4 || !Number.isFinite(r.expiresAt) || r.expiresAt <= now || r.expiresAt > now + RETENTION) return null;
      return {version:4,expiresAt:r.expiresAt,first:cleanTouch(r.first),last:cleanTouch(r.last)};
    } catch (_) { return null; }
  }
  function cleanTouch(touch) {
    if (!touch) return null;
    const values = clean(touch.values);
    if (!Object.keys(values).length) return null;
    return {values:values,landing:typeof touch.landing === 'string' && /^\/(?:pages\/(?:corporate|contact-us)|blogs\/tips-how-tos\/corporate-event-bar-hire-sydney)\/?$/.test(touch.landing) ? touch.landing : '',capturedAt:Number.isFinite(touch.capturedAt) ? touch.capturedAt : 0};
  }
  function attribution() {
    const consent = permissions();
    if (!consent.marketing) {
      let hadPermittedRecord = !!memory;
      try { hadPermittedRecord = hadPermittedRecord || sessionStorage.getItem(STORE) !== null; } catch (_) {}
      if (lastPermission === true || (consent.ready && hadPermittedRecord)) {
        // This essential boolean contains no campaign data. It prevents a reload/regrant from recapturing a withdrawn visit.
        suppression = true;
        try { sessionStorage.setItem(WITHDRAWN,'1'); } catch (_) {}
      }
      if (consent.ready) { lastPermission = false; queryHandled = true; }
      purge();
      return {};
    }
    lastPermission = true;
    let previous = memory || storedRecord();
    if (previous && previous.expiresAt <= Date.now()) previous = null;
    if (!queryHandled && !suppression) {
      const query = new URLSearchParams(window.location.search);
      const incoming = {};
      let present = false;
      KEYS.forEach(function(key) {
        const values = query.getAll(key);
        if (values.length) present = true;
        if (values.length === 1) incoming[key] = values[0];
      });
      if (present) {
        const values = clean(incoming);
        const touch = Object.keys(values).length ? {values:values,landing:window.location.pathname,capturedAt:Date.now()} : null;
        previous = {version:4,expiresAt:previous ? previous.expiresAt : Date.now()+RETENTION,first:previous && previous.first || touch,last:touch};
      }
      queryHandled = true;
    }
    // Direct navigation never refreshes the retention timer or merges old campaign components.
    memory = previous;
    try {
      sessionStorage.removeItem('tdcp_attribution_v3');
      if (memory) sessionStorage.setItem(STORE,JSON.stringify(memory)); else sessionStorage.removeItem(STORE);
    } catch (_) { /* Same-page memory remains usable. Cross-page preservation is unavailable. */ }
    return memory && memory.last ? memory.last.values : {};
  }
  function decorate() {
    const values = attribution();
    // Never reload a mounted form to change attribution: doing so can erase an in-progress brief.
    // Embedded attribution remains unavailable until native Forms consent/mapping is verified.
    document.querySelectorAll('a[href]').forEach(function(element) {
      const attribute = 'href';
      const raw = element.getAttribute(attribute);
      try {
        const url = new URL(raw,window.location.origin);
        if (FORMS.indexOf(url.origin + url.pathname) === -1) return;
        KEYS.concat(['tr_wave']).forEach(function(key) { url.searchParams.delete(key); });
        Object.keys(values).forEach(function(key) { url.searchParams.set(key,values[key]); });
        const root = element.closest && element.closest('#td-corporate-premium');
        const alias = root && root.dataset.tdFormatParam || '';
        // No new context/CRM aliases until the Forms receiving fields are verified.
        if (/^[A-Za-z][A-Za-z0-9_]{0,79}$/.test(alias) && element.dataset.tdFormat) url.searchParams.set(alias,element.dataset.tdFormat);
        element.setAttribute('referrerpolicy','no-referrer');
        if (url.toString() !== raw) element.setAttribute(attribute,url.toString());
      } catch (_) { /* Ordinary links remain usable even when optional tracking fails. */ }
    });
  }
  function init() {
    cleanup();
    decorate();
    const root = document.getElementById('td-corporate-premium');
    if (!root) return;
    const hero = root.querySelector('[data-td-hero]');
    const final = root.querySelector('[data-td-final]');
    const sticky = root.querySelector('[data-td-sticky]');
    const media = window.matchMedia('(max-width:720px)');
    let pastHero = false;
    let nearFinal = false;
    let observers = [];
    function setSticky() {
      if (!sticky) return;
      let visible = media.matches && pastHero && !nearFinal;
      // Never hide the element while a keyboard user is interacting with it.
      if (!visible && sticky.contains(document.activeElement)) visible = true;
      sticky.classList.toggle('is-visible',visible);
      sticky.setAttribute('aria-hidden',String(!visible));
      sticky.toggleAttribute('inert',!visible);
      sticky.querySelectorAll('a').forEach(function (a) { a.tabIndex = visible ? 0 : -1; });
    }
    function refresh() { decorate(); }
    function click(event) {
      const link = event.target.closest && event.target.closest('a[data-td-lead]');
      if (!link || !root.contains(link)) return;
      refresh();
      if (permissions().analytics) {
        // Intent only. Do not label a click as a successfully submitted enquiry.
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({event:'tdcp_enquiry_click',cta_placement:link.dataset.tdPlacement || '',activation_format:link.dataset.tdFormat || 'not_selected',page_path:window.location.pathname});
      }
    }
    if ('IntersectionObserver' in window && hero && final && sticky) {
      const h = new IntersectionObserver(function(entries) { pastHero = entries[0].boundingClientRect.bottom <= 0; setSticky(); });
      const f = new IntersectionObserver(function(entries) { nearFinal = entries[0].isIntersecting || entries[0].boundingClientRect.bottom < 0; setSticky(); },{rootMargin:'0px 0px 100px 0px'});
      h.observe(hero);f.observe(final);observers = [h,f];
    }
    if (media.addEventListener) media.addEventListener('change',setSticky);
    if (sticky) sticky.addEventListener('focusout',setSticky);
    root.addEventListener('click',click);
    refresh();setSticky();
    cleanup = function () {
      observers.forEach(function (o) { o.disconnect(); });
      if (media.removeEventListener) media.removeEventListener('change',setSticky);
      if (sticky) sticky.removeEventListener('focusout',setSticky);
      root.removeEventListener('click',click);
    };
  }
  window.TDCPSearchV4 = {refresh:init};
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',function(event) { if (event.target.querySelector && event.target.querySelector('#td-corporate-premium')) cleanup(); });
  document.addEventListener('visitorConsentCollected',decorate);
  document.addEventListener('click',function(event) { if (event.target.closest && event.target.closest('a[href]')) decorate(); },true);
  const shop = window.Shopify;
  if (shop && !shop.customerPrivacy && typeof shop.loadFeatures === 'function') {
    shop.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error) { if (!error) decorate(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
}());
